module.exports = function errorHandler(errObject = {}, statusCodeMsgs, errorCb) {

  let statusCode, errMessage, errMsg;

  if(errObject.error && !errObject.data) {
    errObject = {data: errObject.error};
  }
  else if(errObject instanceof Error) {
    errObject = {data: {error: errObject}};
  }

  console.error(`ErrorHandler with error: ${JSON.stringify(errObject)}`);
  
  try {
    statusCode = errObject.data.error.status || errObject.data.error.statusCode;
  } catch(err) {}

  try {
    errMsg = errObject.data.error.message;
  } catch(err) {
    errMessage = statusCodeMsgs.default;
  }
  errorCb(statusCodeMsgs[statusCode] || statusCodeMsgs.default || errMsg || errObject.message);
}



// WEBPACK FOOTER //
// ./js/containers/core/services/errorHandler.js